<canvas class="mychart" id="line-{{id}}"></canvas>
